import { configureStore, ReducersMapObject } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { exchangeReducer, ExchangeSchema } from "./reducers/exchange";
import { signInReducer, SignInSchema } from "./reducers/signIn";
import { cabinetReducer, CabinetSchema } from "./reducers/cabinet";
import { passwordReducer, PasswordSchema } from "./reducers/setupPassword";
export interface ThunkExtraArg {}

export interface StateSchema {
  exchange: ExchangeSchema;
  signIn: SignInSchema;
  cabinet: CabinetSchema;
  setPassword: PasswordSchema;
}
export interface ErrorField {
  field: string;
  message: string;
}
export interface ThunkConfig<T> {
  rejectValue: T;
  extra: ThunkExtraArg;
  state: StateSchema;
}

export function createReduxStore(initialState?: StateSchema) {
  const rootReducers: ReducersMapObject<StateSchema> = {
    exchange: exchangeReducer,
    signIn: signInReducer,
    cabinet: cabinetReducer,
    setPassword: passwordReducer,
  };

  // [TODO]: Reducer Manager
  const extraArg: ThunkExtraArg = {};

  const store = configureStore({
    reducer: rootReducers,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: extraArg,
        },
      }),
  });

  return store;
}

export type AppDispatch = ReturnType<typeof createReduxStore>["dispatch"];

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<StateSchema> = useSelector;
